var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTourIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 5.8L9.58034 5L7.91304 9.8H18.087L16.4197 5L13 5.8ZM4 11.4V10.6H22V11.4H4ZM9.08696 20.2C10.5997 20.2 11.8261 18.9464 11.8261 17.4C11.8261 15.8536 10.5997 14.6 9.08696 14.6C7.57417 14.6 6.34783 15.8536 6.34783 17.4C6.34783 18.9464 7.57417 20.2 9.08696 20.2ZM12.5872 17C12.3925 15.2 10.8997 13.8 9.08696 13.8C7.14195 13.8 5.56522 15.4118 5.56522 17.4C5.56522 19.3882 7.14195 21 9.08696 21C10.8997 21 12.3925 19.6 12.5872 17.8H13.4128C13.6075 19.6 15.1003 21 16.913 21C18.8581 21 20.4348 19.3882 20.4348 17.4C20.4348 15.4118 18.8581 13.8 16.913 13.8C15.1003 13.8 13.6075 15.2 13.4128 17H12.5872ZM14.1739 17.4C14.1739 18.9464 15.4003 20.2 16.913 20.2C18.4258 20.2 19.6522 18.9464 19.6522 17.4C19.6522 15.8536 18.4258 14.6 16.913 14.6C15.4003 14.6 14.1739 15.8536 14.1739 17.4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourIcon);
export default __webpack_public_path__ + "static/media/TourIcon.d0566be749aff8bfcc3190c7fcfb66cb.svg";
export { ForwardRef as ReactComponent };